
import { useState } from "react";
import { useDevices } from "@/hooks/useDevices";
import { getDeviceStatus } from "@/utils/deviceStatus";
import { DevicesByDepartment } from "@/components/dashboard/DevicesByDepartment";
import { DevicesByLocation } from "@/components/dashboard/DevicesByLocation";
import { RecentActivities } from "@/components/dashboard/RecentActivities";
import { DashboardAnalytics } from "@/components/dashboard/DashboardAnalytics";
import { DashboardDataTable } from "@/components/dashboard/DashboardDataTable";
import { DeviceStatusDistributionChart } from "@/components/dashboard/DeviceStatusDistributionChart";

export default function AnalyticsDashboard() {
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const { data: devices = [], isLoading } = useDevices();

  const handleStatusClick = (status: string | null) => {
    setStatusFilter(status === statusFilter ? null : status);
  };

  // Calculate device counts
  const counts = devices.reduce((acc, device) => {
    const status = getDeviceStatus(device.last_seen || device.created_at, device.status);
    acc[status]++;
    acc.total++;
    return acc;
  }, { active: 0, inactive: 0, pending: 0, total: 0 });

  console.log('AnalyticsDashboard - Device counts:', counts);
  console.log('AnalyticsDashboard - Total devices:', devices.length);

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900 p-6 w-full font-poppins">
      <div className="max-w-full mx-auto">
        <h1 className="text-2xl font-bold mb-6 text-slate-900 dark:text-white">Dashboard</h1>
        <p className="text-slate-500 dark:text-slate-400 mb-6">
          Key metrics and insights for your device management system.
        </p>
        
        <div className="mt-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <DevicesByDepartment />
            <DevicesByLocation />
          </div>
          
          <div className="mb-6">
            <RecentActivities />
          </div>
          
          <DashboardAnalytics />
          
          {/* Data table component below all charts */}
          <DashboardDataTable />
        </div>
      </div>
    </div>
  );
}
